<app-card-layout-content class="page404">
  <app-card-layout-content-header [noLogo]="true">
    <app-card-layout-content-image>
      <app-feedback-failure-svg-icon></app-feedback-failure-svg-icon>
    </app-card-layout-content-image>
    <app-card-layout-content-title>
      <h1>404</h1>
    </app-card-layout-content-title>
    <app-card-layout-content-description>
      <h3 class="page404__description" i18n>Pagina non trovata</h3>
      <span i18n>La pagina non esiste o è stata rimossa</span>
    </app-card-layout-content-description>
  </app-card-layout-content-header>
</app-card-layout-content>
